import { NostosService } from './../../services/nostos.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatTableDataSource } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { Instance } from '../../models/instance';
import { MatIconModule } from '@angular/material/icon';
import { LoadingSpinnerDialogComponent } from '../../dialogs/loading-spinner/loading-spinner-dialog.component';
import { finalize, interval, startWith, switchMap } from 'rxjs';
import { DatePipe } from '@angular/common';
import { MatSort } from '@angular/material/sort';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    DatePipe,
    MatIconModule
  ]
})
export class DashboardComponent implements OnInit {

  displayedColumns: string[] = [
    'accountName',
    'assetId',
    'openProblems',
    'newestProblem',
    'oldestProblem',
    'lastSyncTs',
    'stewardVersion',
    'osVersion',
    'pluginVersion'
  ];
  dataSource = new MatTableDataSource<Instance>([]);
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private nostosService: NostosService, private dialog: MatDialog) { }

  ngOnInit() {

    this.load();

    // register the timer

    interval(30000).pipe(
      startWith(30000),
      switchMap(() =>
        this.nostosService.getInstances().pipe(
        )
      )
    ).subscribe({
      next: instances => {
        this.dataSource.data = instances;
        this.dataSource.sort = this.sort;
      }
    });

  }

  load() {

    const dialogRef = this.dialog.open(LoadingSpinnerDialogComponent, {
      disableClose: true,
      panelClass: 'loading-dialog'
    });

    this.nostosService.getInstances().pipe(finalize(() => { dialogRef.close(); })).subscribe({
      next: instances => {
        this.dataSource.data = instances;
        this.dataSource.sort = this.sort;
      }
    });

  }

  toDate(seconds: number | null | undefined): Date | null {
    if (seconds == 0) return null;
    return seconds ? new Date(seconds * 1000) : null;
  }

  toDateTs(utcString: string | null | undefined): Date | null {

    if ((utcString) && (utcString.length > 0)) {
      return new Date(utcString.endsWith("Z") ? utcString : utcString + "Z");
    }
    return null;

  }

  openProblems(hostId: string) {

    window.open(this.nostosService.getProblemsUrl(hostId), '_blank');

  }

  openCharts(hostId: string) {

    window.open(this.nostosService.getChartsUrl(hostId), '_blank');

  }

   isOld(utcString: string): boolean {

    if (!utcString) return true;
    if (utcString.length == 0) return true;
    const ts = new Date(utcString.endsWith("Z") ? utcString : utcString + "Z").getTime();
    const now = Date.now();
    return (now - ts) > 5 * 60 * 1000;

  }

  reload() {

    this.load();

  }

}

